import { PipeTransform, Pipe } from '@angular/core';

@Pipe({name: 'splitBy'})
export class SplitPipe implements PipeTransform {
  transform(value: string, char?: string): string[] {
    return value.split(char);
  }
}
